var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-img", {
    staticClass: "align-center d-inline-block vertical-align",
    class: { "cursor-pointer": _vm.showDocument },
    attrs: {
      height: _vm.height,
      width: _vm.width,
      "max-width": _vm.width,
      src: _vm.imgSrc
    },
    on: {
      click: function($event) {
        $event.stopPropagation()
        $event.preventDefault()
        return _vm.openDocument()
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c076ce4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c076ce4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BqaCertificateIcon.vue
// module id = null
// module chunks = 